import React, { useEffect } from 'react';
import Blob from './Blob';
import Employer from './Employer';
import Location from './Location';
import { axiosInstance } from 'src/api/axios';
import APIEndpoints from 'src/Admin/api/APIEndpoints';
import { HttpSuccessCodes } from 'src/Admin/errorhandling/HttpErrorCodes';
import { useDispatch, useSelector } from 'react-redux';
import { setBlobData } from 'src/redux/admin/reportsSlice';
import ShowSelectedData from './Component/ShowSelectedData';

const ReportsBLOB = () => {
  const dispatch = useDispatch();
  const { userData } = useSelector((state) => state?.user);
  const { blobData } = useSelector((state) => state?.reports);
  const { Network_Setting } =
    useSelector((state) => state.app?.appConfigs) || {};
  const { Broker_User_Creation_Setting } = Network_Setting;

  const cacheBuster = (url) => `${url}?cb=${Date.now()}`;

  const getBlobData = async () => {
    try {
      const BlobListResponse = await axiosInstance.get(
        cacheBuster(APIEndpoints.getBLOBListResources() + 'pagesize/5000'),
      );
      if (BlobListResponse.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200) {
        if (BlobListResponse?.data?.Response?.BlockOfBusiness) {
          if (blobData?.selectedBlobData) {
            const blobList = BlobListResponse?.data?.Response?.BlockOfBusiness;
            const tempObj = blobList.map((item) =>
              blobData?.selectedBlobData?.BlkOfBusId === item?.BlkOfBusId
                ? { ...item, isChecked: true }
                : item,
            );
            dispatch(setBlobData({ allBlobData: tempObj }));
            return { ...blobData, allBlobData: tempObj };
          } else {
            dispatch(
              setBlobData({
                allBlobData: BlobListResponse?.data?.Response?.BlockOfBusiness,
              }),
            );
            return {
              ...blobData,
              allBlobData: BlobListResponse?.data?.Response?.BlockOfBusiness,
            };
          }
        }
      }
    } catch (error) {
      console.log(error);
      return { isError: true, errorObj: error };
    }
  };

  const getEmployerData = async () => {
    try {
      let apiUrl = '';
      if (
        blobData?.selectedBlobData?.BlkOfBusId ||
        (blobData?.selectedBlobData?.from && blobData?.selectedBlobData?.to)
      ) {
        apiUrl = APIEndpoints.getBlobRangeResources();
        if (blobData?.selectedBlobData?.BlkOfBusId) {
          if (blobData?.blobType === 'single') {
            apiUrl =
              apiUrl +
              'blkofbusidfrom/' +
              blobData?.selectedBlobData?.BlkOfBusId +
              '/blkofbusidto/' +
              blobData?.selectedBlobData?.BlkOfBusId +
              '/pagesize/5000';
          }
        }
        if (blobData?.blobType === 'range') {
          apiUrl =
            apiUrl +
            'blkofbusidfrom/' +
            blobData?.selectedBlobData?.from +
            '/blkofbusidto/' +
            blobData?.selectedBlobData?.to +
            '/pagesize/5000';
        }
      } else {
        apiUrl = APIEndpoints.getEmployerListResources() + 'pagesize/5000/';
        if (blobData?.selectedBlobData?.oid) {
          apiUrl = apiUrl + 'blkofbusoid/' + blobData?.selectedBlobData?.oid;
        }
      }
      const EmployerListResponse = await axiosInstance.get(cacheBuster(apiUrl));
      if (
        EmployerListResponse.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200
      ) {
        if (EmployerListResponse?.data?.Response?.Client) {
          const employerList = EmployerListResponse?.data?.Response?.Client;
          const tempObj = employerList.map((item) =>
            blobData?.selectedEmployerData?.oid === item?.oid
              ? { ...item, isChecked: true }
              : item,
          );
          dispatch(setBlobData({ allEmployerData: tempObj }));
          return { ...blobData, allEmployerData: tempObj };
        } else {
          dispatch(
            setBlobData({
              allEmployerData: EmployerListResponse?.data?.Response?.Client,
            }),
          );
          return {
            ...blobData,
            allEmployerData: EmployerListResponse?.data?.Response?.Client,
          };
        }
      }
    } catch (error) {
      dispatch(setBlobData({ allEmployerData: [] }));
      return { isError: true, errorObj: error };
    }
  };

  const getLocationData = async () => {
    try {
      let apiUrl = APIEndpoints.getLocationListResources() + 'pagesize/5000/';
      if (blobData?.selectedEmployerData?.oid) {
        apiUrl = apiUrl + 'clientoid/' + blobData?.selectedEmployerData?.oid;
      }
      const LocationListResponse = await axiosInstance.get(cacheBuster(apiUrl));
      if (
        LocationListResponse.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200
      ) {
        if (LocationListResponse?.data?.Response?.Client) {
          const locationList = LocationListResponse?.data?.Response?.Location;
          const tempObj = locationList.map((item) =>
            blobData?.selectedLocationData?.oid === item?.oid
              ? { ...item, isChecked: true }
              : item,
          );
          dispatch(setBlobData({ allLocationData: tempObj }));
          return { ...blobData, allLocationData: tempObj };
        } else {
          dispatch(
            setBlobData({
              allLocationData: LocationListResponse?.data?.Response?.Location,
            }),
          );
          return {
            ...blobData,
            allLocationData: LocationListResponse?.data?.Response?.Location,
          };
        }
      }
    } catch (error) {
      dispatch(setBlobData({ allLocationData: [] }));
      return { isError: true, errorObj: error };
    }
  };

  const deleteBlob = () => {
    const resetAllBlobData = blobData?.allBlobData?.map((item) => {
      return { ...item, isChecked: false };
    });
    dispatch(
      setBlobData({ allBlobData: resetAllBlobData, selectedBlobData: {} }),
    );
    deleteEmployer();
    deleteLocation();
  };

  const deleteEmployer = () => {
    const resetAllEmployerData = blobData?.allEmployerData?.map((item) => {
      return { ...item, isChecked: false };
    });
    dispatch(
      setBlobData({
        allEmployerData: resetAllEmployerData,
        selectedEmployerData: {},
      }),
    );
    deleteLocation();
  };

  const deleteLocation = () => {
    const resetAllLocationData = blobData?.allLocationData?.map((item) => {
      return { ...item, isChecked: false };
    });
    dispatch(
      setBlobData({
        allLocationData: resetAllLocationData,
        selectedLocationData: {},
      }),
    );
  };

  return (
    <div className="reports-blob-ui-container">
      {!(
        blobData?.selectedBlobData?.oid ||
        blobData?.selectedBlobData?.from ||
        blobData?.selectedEmployerData?.oid ||
        blobData?.selectedEmployerData?.from ||
        blobData?.selectedLocationData?.oid ||
        blobData?.selectedLocationData?.from
      ) ? (
        <>
          {userData.UserType !== 'Client' && userData.UserType !== 'Broker' && (
            <Blob
              blobData={blobData}
              dispatch={dispatch}
              setBlobData={setBlobData}
              fetchData={getBlobData}
            />
          )}
          {userData.UserType === 'Broker' &&
            Broker_User_Creation_Setting === true && (
              <Blob
                blobData={blobData}
                dispatch={dispatch}
                setBlobData={setBlobData}
                fetchData={getBlobData}
              />
            )}
          <Employer
            blobData={blobData}
            dispatch={dispatch}
            setBlobData={setBlobData}
            fetchData={getEmployerData}
          />
          <Location
            blobData={blobData}
            dispatch={dispatch}
            setBlobData={setBlobData}
            fetchData={getLocationData}
          />
        </>
      ) : (
        <ShowSelectedData
          blobData={blobData}
          deleteBlob={deleteBlob}
          deleteEmployer={deleteEmployer}
          deleteLocation={deleteLocation}
          getEmployerData={getEmployerData}
          getLocationData={getLocationData}
          dispatch={dispatch}
          setBlobData={setBlobData}
        />
      )}
    </div>
  );
};

export default ReportsBLOB;
